import { useMemo } from "react";
import { cashRegistersLookup } from "../lib/cachedLookups";
import useLookup from "./useLookup";

/** The cash registers as `{ value, label }` options for a select. */
const useCashRegisterOptions = () => {
	const { data: cashRegisters } = useLookup(cashRegistersLookup);
	return useMemo(
		() =>
			(cashRegisters ?? []).map((cashRegister) => ({
				value: cashRegister.id,
				label: cashRegister.description,
			})),
		[cashRegisters]
	);
};

export default useCashRegisterOptions;
